module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_4.416f1e22.png";